//@flow
import React, { useCallback } from "react";
import { connect } from "react-redux";

import { Translate } from "@quantum/i18n";

import moment from "moment";

import {
  type ActionCreator,
  isFechamentoDeMesSelecionado,
  getDataFechamentoMesAnterior,
  selecionarFechamentoDeMes,
  selecionarDataBase,
  selecionarDataBaseDefault,
} from "../../../../state";

type Props = {
  isFechamentoDeMesSelecionado: boolean,
  dataFechamentoMesAnterior: number,
  selecionarFechamentoDeMes: ActionCreator,
  selecionarDataBase: ActionCreator,
  selecionarDataBaseDefault: ActionCreator,
};

function SelecaoFechamentoDeMes({
  isFechamentoDeMesSelecionado,
  dataFechamentoMesAnterior,
  selecionarFechamentoDeMes,
  selecionarDataBase,
  selecionarDataBaseDefault,
}: Props) {
  const aoMudarFechamentoDeMes = useCallback(
    event => {
      const fechamentoDeMesSelecionado = event.target.checked;
      selecionarFechamentoDeMes(fechamentoDeMesSelecionado);
      fechamentoDeMesSelecionado
        ? selecionarDataBase(moment(dataFechamentoMesAnterior))
        : selecionarDataBaseDefault();
    },
    [
      selecionarFechamentoDeMes,
      selecionarDataBase,
      selecionarDataBaseDefault,
      dataFechamentoMesAnterior,
    ]
  );

  return (
    <div className="MedidasSelecionadasHeader__grupo">
      <span className="MedidasSelecionadasHeader__fechamento-mes">
        <input
          type="checkbox"
          checked={isFechamentoDeMesSelecionado}
          onChange={aoMudarFechamentoDeMes}
        />
        <Translate>maiusculas.fechamentoDeMes</Translate>
      </span>
    </div>
  );
}

export default connect(
  state => ({
    isFechamentoDeMesSelecionado: isFechamentoDeMesSelecionado(state),
    dataFechamentoMesAnterior: getDataFechamentoMesAnterior(state),
  }),
  {
    selecionarFechamentoDeMes,
    selecionarDataBase,
    selecionarDataBaseDefault,
  }
)(SelecaoFechamentoDeMes);
